import { render, staticRenderFns } from "./BudgetComponentModal.vue?vue&type=template&id=45f8f2d7&scoped=true&"
import script from "./BudgetComponentModal.vue?vue&type=script&lang=js&"
export * from "./BudgetComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetComponentModal.vue?vue&type=style&index=0&id=45f8f2d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8f2d7",
  null
  
)

export default component.exports